/** The message for a refused name, as the add field and the rename field show it. */
export default function tableNameErrorText(t, problem) {
  if (!problem) {
    return null;
  }

  if (problem.code === 'duplicate') {
    return t('errors.duplicate', { name: problem.name });
  }

  if (problem.code === 'too_long') {
    return t('errors.too_long', { max: problem.max });
  }

  return t('errors.empty');
}
